import { useId } from 'react';
import {
  gaiaTheme,
  getFieldHelperTextClasses,
  getFieldLabelClasses,
  getFieldRequiredClasses,
  getInputClasses,
} from './baseUIConfig';

export function Textarea({
  label,
  error,
  helperText,
  id,
  required = false,
  className = '',
  rows = 4,
  resize = 'vertical',
  ref,
  ...props
}) {
  const generatedId = useId();
  const textareaId = id || generatedId;
  const errorMessage = typeof error === 'string' ? error : '';
  const hasError = Boolean(error);
  const helperId = helperText && !hasError ? `${textareaId}-helper` : undefined;
  const errorId = hasError && errorMessage ? `${textareaId}-error` : undefined;

  const resizeClass = {
    none: 'resize-none',
    vertical: 'resize-y',
    horizontal: 'resize-x',
    both: 'resize',
  }[resize] || 'resize-y';

  return (
    <div className={gaiaTheme.components.field.container}>
      {label && (
        <label htmlFor={textareaId} className={getFieldLabelClasses()}>
          {label}
          {required && <span className={getFieldRequiredClasses()}>*</span>}
        </label>
      )}

      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        className={getInputClasses(hasError, false, `${resizeClass} ${className}`.trim())}
        aria-describedby={errorId || helperId}
        aria-invalid={hasError ? 'true' : 'false'}
        {...props}
      />

      {errorId && (
        <p id={errorId} className={getFieldHelperTextClasses(true)}>
          {errorMessage}
        </p>
      )}

      {helperId && (
        <p id={helperId} className={getFieldHelperTextClasses(false)}>
          {helperText}
        </p>
      )}
    </div>
  );
}
